import { render, staticRenderFns } from "./deliveryWay.vue?vue&type=template&id=4bcdbac0&scoped=true"
import script from "./deliveryWay.vue?vue&type=script&lang=js"
export * from "./deliveryWay.vue?vue&type=script&lang=js"
import style0 from "./deliveryWay.vue?vue&type=style&index=0&id=4bcdbac0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcdbac0",
  null
  
)

export default component.exports